module.exports = __webpack_public_path__ + "img/product_27.a00f407.webp";